const product = { 
  color: '#4674c9',
  dateFormat: 'DD/MM/YYYY',
  favicon: require(`../@theme/images/abcInsurance/favicon.ico`), /**require path cannot be dynamic */
  logo:  require(`../@theme/images/abcInsurance/logo.png`),  /**require path cannot be dynamic */
  title: 'Medical Insurance',
  currencySymbol: 'US$',
  currencyFormat: '0,0.00',
  sections: [
    {title: 'POLICY DETAILS', startIndexInclusive: 0, endIndexInclusive: 3},
    {title: ' ', startIndexInclusive: 4, endIndexInclusive: 7},
    {title: 'MAIN APPLICANT', startIndexInclusive: 8, endIndexInclusive: 10},
    {title: 'BENEFICIARY DETAILS', startIndexInclusive: 11, endIndexInclusive: 20},
  ]
};

export default product;
